import { render, staticRenderFns } from "./coTransferTask.vue?vue&type=template&id=d25dde54&scoped=true"
import script from "./coTransferTask.vue?vue&type=script&lang=js"
export * from "./coTransferTask.vue?vue&type=script&lang=js"
import style0 from "./coTransferTask.vue?vue&type=style&index=0&id=d25dde54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25dde54",
  null
  
)

export default component.exports